module.exports = __webpack_public_path__ + "static/media/matilde-hat-brazil-impressed.cc542a59.png";